module.exports = __webpack_public_path__ + "assets/cfed21d5c09bd74a3fb5f0f292260379.png";